import { formatNumFloat } from "../formatNumFloat";


export const handleInputFloat = (e, setState, values) => {
    const { name, value } = e.target;
    const formatValue = formatNumFloat(value);
    setState( { ...values, [name]:formatValue } );
}
